import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CircularProgress } from "@mui/material";
import moment from "moment";

import { getBatchDetailCardStockNew } from "../../../../services/InventoryAPI";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";

const CardStockDetailNew = ({ isWarehouse }) => {
  const { productId = "" } = useParams();
  const companyId = localStorage.getItem("company_id");
  const navigate = useNavigate();

  const [sort, setSort] = useState(true);

  const { data: dataDetail, isFetching: isFetchingDetail } = useQuery({
    queryKey: ["card-stock-detail-new", productId, companyId, sort],
    queryFn: () =>
      getBatchDetailCardStockNew(
        productId,
        companyId,
        isWarehouse ? isWarehouse : false,
        sort
      ),
    refetchOnWindowFocus: false,
  });

  // useEffect(() => {
  //   if (dataDetail)
  //     setDataBuffer(
  //       dataDetail.data?.map((item) => ({
  //         isOpen: false,
  //         data: [],
  //         ...item,
  //       }))
  //     );
  // }, [dataDetail]);

  // useEffect(() => {
  //   if (dataDetailBatch) {
  //     const temp = [...dataBuffer];
  //     const index = dataBuffer.findIndex(
  //       (item) => item.id === selectedBatch.id
  //     );
  //     temp[index].data = dataDetailBatch;
  //     setDataBuffer(temp);
  //   }
  // }, [dataDetailBatch]);

  return (
    <div>
      <div className="w-full flex gap-2 items-stretch text-white h-full mb-4">
        <div className="w-full rounded-lg bg-[#568CCD] p-3">
          <p className="mb-2">Nama Produk</p>
          <p className="text-[16px]">
            {isFetchingDetail ? (
              <CircularProgress size={20} />
            ) : dataDetail && dataDetail.name !== "" ? (
              dataDetail.name
            ) : (
              "-"
            )}
          </p>
          {/* <p>Obat penurun panas</p> */}
        </div>
        <div className="w-1/2 rounded-lg bg-[#56CDAC] p-3 self-stretch">
          <p className="mb-2">ID Produk</p>
          <p className="text-[16px]">
            {isFetchingDetail ? (
              <CircularProgress size={20} />
            ) : dataDetail ? (
              dataDetail.product_id
            ) : (
              "-"
            )}
          </p>
        </div>
        <div className="w-1/2 rounded-lg bg-[#7A56CD] p-3">
          <p className="mb-2">Total Stok</p>
          <p className="text-[16px]">
            {isFetchingDetail ? (
              <CircularProgress size={20} />
            ) : dataDetail ? (
              dataDetail.total_stock
            ) : (
              "-"
            )}
          </p>
          <p>Unit tersedia</p>
        </div>
      </div>

      <div className="bg-white rounded-lg p-3">
        <div className="flex w-full">
          <div className="w-full">
            <div className="block overflow-x-auto w-full">
              <table className="w-full overflow-x-auto-md border-collapse">
                <thead className="bg-[#F7F8F9]">
                  <th className="p-2 text-center w-fit">No</th>
                  <th className="p-2 text-left w-fit">Nomor Batch</th>
                  <th className="p-2 whitespace-nowrap cursor-pointer hover:text-gray-400">
                    <div
                      className="flex items-center justify-between gap-4 whitespace-nowrap"
                      onClick={() => setSort(!sort)}
                    >
                      <p>Update Terakhir</p>
                      {sort ? <FaSortUp /> : <FaSortDown />}
                    </div>
                  </th>
                  <th className="p-2 text-left w-fit">Tanggal Kedaluwarsa</th>
                  <th className="p-2 text-center w-fit">Stok</th>
                  <th className="p-2 text-center w-fit">UOM</th>
                </thead>
                <tbody>
                  {dataDetail &&
                  dataDetail.data &&
                  dataDetail.data.length > 0 &&
                  !isFetchingDetail ? (
                    dataDetail.data.map((item, i) => (
                      <tr className="text-center border-b" key={i}>
                        <td className="p-3 text-center">{i + 1}</td>
                        <td
                          className="p-2 text-left text-[#071B82] cursor-pointer hover:text-gray-300 font-bold"
                          onClick={() => {
                            navigate(
                              `${
                                isWarehouse ? "/central-warehouse" : ""
                              }/inventory/card-stock/card-stock-detail-batch/${productId}/${
                                item.id
                              }`
                            );
                          }}
                        >
                          {item.batch}
                        </td>
                        <td className="p-3 text-left">
                          {moment(item.created_at).format("DD MMMM YYYY")}
                        </td>
                        <td className="p-3 text-left">
                          {moment(item.expired).format("DD MMMM YYYY")}
                        </td>
                        <td className="p-3 text-center">{item.stock}</td>
                        <td className="p-3 text-center">{item.packaging}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="p-3 text-center border-b">
                        {isFetchingDetail ? (
                          <CircularProgress size={20} />
                        ) : (
                          <div className="py-5">
                            <p className="text-[18px] font-semibold mb-2">
                              Tidak ada detail data
                            </p>
                            <p className="mb-4">Silahkan coba lagi</p>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardStockDetailNew;
